import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuiaModel } from 'src/app/models/guia.model';
import { categoriasPlatillos, PlatilloModel } from 'src/app/models/platillo.model';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DocumentsService } from 'src/app/services/document.service';
import Swal from 'sweetalert2';
import { Chart, ChartOptions, registerables } from 'chart.js';
import { SuplementosComponent } from './suplementos/suplementos.component';
import { AlimentosComponent } from './alimentos/alimentos.component';
import { AlimentosPreparadosComponent } from "./alimentos-preparados/alimentos-preparados.component";
import { UtilsService } from 'src/app/services/utils.service';
import { Dimensions, ImageCroppedEvent } from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UploadService } from 'src/app/services/upload.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
Chart.register(...registerables)
declare var $: any;

@Component({
  selector: 'app-constructor-guias',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    AlimentosComponent,
    SuplementosComponent,
    AlimentosPreparadosComponent
],
  templateUrl: './constructor-guias.component.html',
  styleUrl: './constructor-guias.component.css'
})
export class ConstructorGuiasComponent implements OnInit {
  userInfo: any;
  env: any = environment
  clienteId: string;
  programaId: string;
  detalleCliente: any;
  detallePrograma: any;

  formPlatillos: FormGroup;
  formConstructorPlatillo: FormGroup;
  listaPlatillos: PlatilloModel[] = [];
  listaPlatillosPropios: PlatilloModel[] = [];
  categoriasPlatillos: any = categoriasPlatillos;
  showTabConstructorGuia: boolean = true;
  chartPlatilloInstance: Chart | null = null;
  submitFormConstructorPlatillo: boolean = false;
  editarPlatillo: any = false;
  patternPlatillos: string = 'platillo'
  filtroCategoriaPlatillo = '';
  filtroPropietario = 'todos'

  listaGuias: GuiaModel[] = [];
  // constructorGuia: any = { platillos: [] };
  constructorGuiaModal: any = { platillos: [] }
  editarGuia: any = false;
  patternGuias: string = 'guia'

  // DataTables implementadas
  dataTablePlatillos: any;
  dataTablePlatillosModal: any;
  dataTableConstructorPlatillo: any;
  dataTableConstructorGuia: any;
  dataTableConstructorGuiaModal: any;

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private utilsService: UtilsService,
              private uploadService: UploadService,
              private route: ActivatedRoute,
              private router: Router
  )
  {
    // Object.assign(this, { single });

    this.formPlatillos = this.fb.group
    ({
      items: this.fb.array([]),
    })
    this.formConstructorPlatillo = this.fb.group({
      nombre: ['', [Validators.required]],
      descripcion: [''],
      categoria: ['', [Validators.required]],
      
      calorias: [0],
      carbohidratos: [0],
      proteinas: [0],
      grasas: [0],
      items: this.fb.array([]),
    })
  }

  ngOnInit(): void {
    $('#sidebar-overlay').click();

    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    
    this.route.paramMap.subscribe(params => {
      this.clienteId = params.get('clienteId');
      this.programaId = params.get('programaId');
      // console.log(this.clienteId, this.programaId);
      if(this.clienteId) {
        this.getDetalleCliente();
      } else if(this.programaId) {
        this.getDetallePrograma(this.programaId);
      }
    });

    this.getPlatillos();
    this.getGuias();

    this.inicializarDataTableConstructorGuia();
    this.inicializarDataTableConstructorPlatillo();
  }

  isCollapsedAlimentos = false;
  toggleCollapseAlimentos() {
    this.isCollapsedAlimentos = !this.isCollapsedAlimentos;
  }
  isCollapsedConstructor = false;
  toggleCollapseConstructor() {
    this.isCollapsedConstructor = !this.isCollapsedConstructor;
  }
  isLargeScreen: boolean = window.innerWidth > 991;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isLargeScreen = event.target.innerWidth > 991;
  }
  navigateBack() {
    sessionStorage.setItem('seccion', 'guias');
    if(this.clienteId) { //'expediente cliente'
      sessionStorage.setItem('seccionProgramaId', this.programaId);
      this.router.navigate(['trainer/config-programa', this.detalleCliente.documentId])
    } else { //'programa prediseñado'
      this.router.navigate(['trainer/config-programa', this.programaId])
    }
  }

  /**************************************************/
  /*************** GET's Informacion ****************/
  getPlatillos()
  {
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtroCategoriaPlatillo != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtroCategoriaPlatillo
        }
      });
    }
    let should: any = []
    switch (this.filtroPropietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
        {
          "bool": { should }
        }
    )
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.patternPlatillos, query).subscribe({
        next: (data: any) => {
          console.log('listaPlatillos', data)
          if(this.dataTablePlatillos) {
            this.dataTablePlatillos.destroy();
            this.dataTablePlatillos = null; // Eliminar la referencia
          }
          this.listaPlatillos = [];
          this.listaPlatillos = data;
          this.setFormPlatillos();

          // Setea lista de platillos propios
          if(this.filtroPropietario == 'todos' || this.filtroPropietario == 'propios') {
            this.listaPlatillosPropios = this.listaPlatillos.filter(p => p.propietario == this.userInfo.documentContainerId && !p.guiaId);
            // console.log('listaPlatillosPropios', this.listaPlatillosPropios)
          }
        },
        error: (error: any) => {
          console.error(error);
          this.setFormPlatillos();
        }
      });
    }, 1500);
  }
  setFormPlatillos()
  {
    const arreglo = this.formPlatillos.get('items') as FormArray;
    // Vacía el FormArray eliminando todos los controles
    while (arreglo.length !== 0) {
      arreglo.removeAt(0);
    }

    for(let platillo of this.listaPlatillos)
    {
      const grupo = this.fb.group({
        pla_asignado: [false, [Validators.required]], //cambia el valor del checkbox

        nombre: platillo.nombre,
        categoria: platillo.categoria,
        descripcion: platillo.descripcion,
        imagenUrl: platillo.imagen ? platillo.imagen.url : null,
        // elementos: platillo.elementos,
        cal: platillo.calorias,
        gC: platillo.carbohidratos, // Gramos de carbohidratos
        gP: platillo.proteinas, // Gramos de proteínas
        gG: platillo.grasas, // Gramos de grasas
        propietario: platillo.propietario,
        objInfo: platillo // Guarda todo el objeto del platillo
      })
      arreglo.push(grupo);
    }
    this.inicializarDataTablePlatillos();
  }

  getGuias()
  {
    const filters: any = {
      "documentContainerId": this.userInfo.documentContainerId,
      "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.patternGuias, query).subscribe({
        next: (data: any) => {
          console.log(data)
          this.listaGuias = [];
          this.listaGuias = data;
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }, 1500);
  }
  getDetalleCliente()
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, this.clienteId).subscribe((res: any) => {
      console.log('detalleCliente', res)
      this.detalleCliente = res;

      const programasCliente = this.detalleCliente.expediente?.programas;
      const index = programasCliente.findIndex((p) => p.configuracionPrograma.id == this.programaId);
      if(index != -1) {
        this.detallePrograma = programasCliente[index];
      }
    }, err => {
      console.error(err)
    })
  }
  getDetallePrograma(documentId)
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, documentId).subscribe((res: any) => {
      console.log('detallePrograma', res)
      this.detallePrograma = res;
    }, err => {
      console.error(err)
    })
  }

  /**************************************************/
  /************* Inicializar DataTables *************/
  inicializarDataTablePlatillos()
  {
    if (this.dataTablePlatillos) {
      this.dataTablePlatillos.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTablePlatillos = $('#dataTable-listaPlatillos').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  inicializarDataTablePlatillosModal()
  {
    if (this.dataTablePlatillosModal) {
      this.dataTablePlatillosModal.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTablePlatillosModal = $('#dataTable-listaPlatillos-modal').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  inicializarDataTableConstructorPlatillo()
  {
    if (this.dataTableConstructorPlatillo) {
      this.dataTableConstructorPlatillo.destroy(); // Destruye cualquier instancia previa
      this.dataTableConstructorPlatillo = null; // Asegúrate de limpiar la referencia
    }
    $(document).ready(() => {
      this.dataTableConstructorPlatillo = $('#dataTable-constructorPlatillo').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  inicializarDataTableConstructorGuia() {
    const tableId = '#dataTable-constructorGuia';
  
    // Destruir DataTable si ya está inicializada
    if ($.fn.DataTable.isDataTable(tableId)) {
      $(tableId).DataTable().destroy();
    }
  
    // Asegurarse de que el DOM está actualizado antes de reiniciar DataTable
    setTimeout(() => {
      $(tableId).DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla",
        },
        pageLength: 10,
      });
    }, 0); // Retardo para esperar a que el DOM se actualice
  }
  inicializarDataTableConstructorGuiaModal()
  {
    if (this.dataTableConstructorGuiaModal) {
      this.dataTableConstructorGuiaModal.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableConstructorGuiaModal = $('#dataTable-constructorGuia-modal').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  /**************************************************/
  /********** AGREGAR ELEMENTOS A PLATILLO **********/
  /**************************************************/
  setFormConstructorPlatillo(ingrediente, inicializarDataTable, newIngrediente)
  {
    if(this.dataTableConstructorPlatillo) {
      this.dataTableConstructorPlatillo.destroy();
      this.dataTableConstructorPlatillo = null; // Eliminar la referencia
    }
    if(this.showTabConstructorGuia) this.showTabConstructorGuia = false;
    const arreglo = this.formConstructorPlatillo.get('items') as FormArray;
    const index = arreglo.controls.findIndex(control => 
      control.value.nombre === ingrediente.nombre &&
      control.value.documentId === ingrediente.documentId
    );
  
    if (index !== -1) {
      Swal.fire({
        toast: true, // Activa el estilo tipo Toast
        position: 'bottom-end', // Posición del mensaje
        icon: 'warning',
        title: 'El ingrediente ya existe en el platillo.',
        showConfirmButton: false,
        timer: 3000, // Tiempo de duración del mensaje (3 segundos)
        timerProgressBar: true // Muestra una barra de progreso
      });
      return;
    }

    const grupo = this.fb.group({
      documentId: ingrediente.documentId,
      nombre:         ingrediente.nombre,
      categoria:      ingrediente.categoria,
      unidad:         ingrediente.unidad,
      porcion:        [!newIngrediente ? ingrediente.porcionPlatillo : ingrediente.porcion, [Validators.required]],
      calorias:       !newIngrediente ? ingrediente.caloriasPlatillo : ingrediente.calorias,
      carbohidratos:  !newIngrediente ? ingrediente.carbohidratosPlatillo : ingrediente.carbohidratos, // Gramos de carbohidratos
      proteinas:      !newIngrediente ? ingrediente.proteinasPlatillo : ingrediente.proteinas, // Gramos de proteínas
      grasaTotal:     !newIngrediente ? ingrediente.grasaTotalPlatillo : ingrediente.grasaTotal, // Gramos de grasas

      porcionOriginal: ingrediente.porcion,
      caloriasPorPorcion: ingrediente.calorias,
      carbohidratosPorPorcion: ingrediente.carbohidratos, // Gramos de carbohidratos
      proteinasPorPorcion: ingrediente.proteinas, // Gramos de proteínas
      grasaTotalPorPorcion: ingrediente.grasaTotal, // Gramos de grasas
      objInfo: ingrediente // se guarda todo el objeto
    })

    grupo.get('porcion').valueChanges.subscribe((value) => {
      grupo.patchValue({
        calorias: (value * Number(grupo.get('caloriasPorPorcion').value)) / Number(grupo.get('porcionOriginal').value),
        carbohidratos: (value * Number(grupo.get('carbohidratosPorPorcion').value)) / Number(grupo.get('porcionOriginal').value),
        proteinas: (value * Number(grupo.get('proteinasPorPorcion').value)) / Number(grupo.get('porcionOriginal').value),
        grasaTotal: (value * Number(grupo.get('grasaTotalPorPorcion').value)) / Number(grupo.get('porcionOriginal').value)
      })
      this.calculoCaloriasPlatillo();
    });

    arreglo.push(grupo);
    this.calculoCaloriasPlatillo();
    if(inicializarDataTable) this.inicializarDataTableConstructorPlatillo();
  }
  
  changeShowTabConstructorGuiaVal(val) {
    this.showTabConstructorGuia = val;
  }

  calculoCaloriasPlatillo() {
    let caloriasPlatillo = 0;
    let carbohidratosPlatillo = 0;
    let proteinasPlatillo = 0;
    let grasasPlatillo = 0;
  
    // Suma los valores de los ingredientes
    for (let ingrediente of this.formConstructorPlatillo.get('items').value) {
      caloriasPlatillo += Number(ingrediente.calorias);
      carbohidratosPlatillo += Number(ingrediente.carbohidratos);
      proteinasPlatillo += Number(ingrediente.proteinas);
      grasasPlatillo += Number(ingrediente.grasaTotal);
    }
  
    // Calcula el porcentaje de cada macronutriente
    let porcentajeCarbohidratos = ((carbohidratosPlatillo * 4) / caloriasPlatillo) * 100 || 0;
    let porcentajeProteinas = ((proteinasPlatillo * 4) / caloriasPlatillo) * 100 || 0;
    let porcentajeGrasas = ((grasasPlatillo * 9) / caloriasPlatillo) * 100 || 0;

    // Ajusta los porcentajes para que sumen 100%
    let sumaPorcentajes = porcentajeCarbohidratos + porcentajeProteinas + porcentajeGrasas;
    porcentajeCarbohidratos = (porcentajeCarbohidratos / sumaPorcentajes) * 100;
    porcentajeProteinas = (porcentajeProteinas / sumaPorcentajes) * 100;
    porcentajeGrasas = (porcentajeGrasas / sumaPorcentajes) * 100;
  
    // Actualiza el formulario
    this.formConstructorPlatillo.patchValue({
      calorias: caloriasPlatillo,
      carbohidratos: carbohidratosPlatillo,
      proteinas: proteinasPlatillo,
      grasas: grasasPlatillo
    });
  
    // Crea el gráfico con los porcentajes calculados
    this.createPieChartPlatillo('pieChart', porcentajeCarbohidratos, porcentajeProteinas, porcentajeGrasas);
  }
  
  createPieChartPlatillo(htmlId:string, pCarbohidratos: number, pProteinas: number, pGrasas: number): void {
    const ctx = document.getElementById(htmlId) as HTMLCanvasElement;
  
    // Destruye el gráfico anterior si existe
    if (this.chartPlatilloInstance) {
      this.chartPlatilloInstance.destroy();
    }
  
    // Crea un nuevo gráfico y almacena la instancia
    this.chartPlatilloInstance = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: [
          `Carbohidratos ${pCarbohidratos.toFixed(2)}%`,
          `Proteínas ${pProteinas.toFixed(2)}%`,
          `Grasas ${pGrasas.toFixed(2)}%`
        ],
        datasets: [{
          label: '%',
          data: [pCarbohidratos, pProteinas, pGrasas],
          backgroundColor: ['rgb(75, 192, 75)', 'rgb(255, 206, 86)','rgb(243, 78, 78)'],
          borderColor: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          tooltip: {
            enabled: true
          }
        }
      } as ChartOptions
    });
  }
  // Método para inicializar (o resetear) el gráfico
  inicializarChart(): void {
    const ctx = document.getElementById('pieChart') as HTMLCanvasElement;

    // Destruye el gráfico anterior si existe
    if (this.chartPlatilloInstance) {
      this.chartPlatilloInstance.destroy();
      this.chartPlatilloInstance = null; // Limpiar referencia
    }

    // Opcionalmente, puedes dejar el lienzo vacío o con un mensaje predeterminado
    const emptyData = {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      }],
    };

    this.chartPlatilloInstance = new Chart(ctx, {
      type: 'pie',
      data: emptyData,
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false, // Oculta la leyenda en el gráfico vacío
          },
          tooltip: {
            enabled: false, // Desactiva los tooltips en el gráfico vacío
          }
        }
      } as ChartOptions,
    });
  }

  removeIngrediente(ingrediente: any) {
    const arreglo = this.formConstructorPlatillo.get('items') as FormArray;
    const index = arreglo.controls.findIndex(control => 
      control.value.nombre === ingrediente.nombre &&
      control.value.categoria === ingrediente.categoria
    );
  
    if (index !== -1) {
      arreglo.removeAt(index);
      this.inicializarDataTableConstructorPlatillo();
      this.calculoCaloriasPlatillo();
    }
  }

  /************** Funciones para agregar|editar|eliminar platillo **************************/
  editarPlatilloExclusivoGuia = false;
  goEditarPlatillo(platillo, editadoDesde: 'biblioteca' | 'guia')
  {
    console.log('platillo', platillo)
    console.log('editadoDesde', editadoDesde)
    if(this.formConstructorPlatillo.get('items').value.length > 0)
    {
      Swal.fire('Advertencia', "No se puede agregar un platillo a una comida que ya tiene alimentos.<br> Elimine los alimentos de la comida si quiere agregar el platillo.", 'warning');
      return;
    }
    if(editadoDesde == 'biblioteca') this.editarPlatillo = platillo;
    if(editadoDesde == 'guia') {
      console.log('listaPlatillos', this.listaPlatillos)
      console.log('documentId', platillo.documentId)
      const index = this.listaPlatillos.findIndex(p => p.documentId == platillo.documentId);
      console.log('index', index)
      if(index != -1) {
        this.editarPlatillo = this.listaPlatillos[index];
        if(this.editarPlatillo.guiaId) this.editarPlatilloExclusivoGuia = true;
      }
      if(index == -1) {
        Swal.fire('Advertencia', 'Error al editar platillo de guía.', 'warning');
        return;
      }
    }
    // console.log(this.editarPlatillo)
    
    this.errorFileType(false)
    if(this.editarPlatillo.imagen) this.previewUrl = this.editarPlatillo.imagen.url;

    this.formConstructorPlatillo.patchValue({
      nombre: this.editarPlatillo.nombre,
      descripcion: this.editarPlatillo.descripcion,
      categoria: this.editarPlatillo.categoria,
      calorias: this.editarPlatillo.calorias,
      carbohidratos: this.editarPlatillo.carbohidratos,
      grasas: this.editarPlatillo.grasas,
    })

    for(let ingrediente of this.editarPlatillo.detalle) this.setFormConstructorPlatillo(ingrediente, false, false);
    this.inicializarDataTableConstructorPlatillo();
  }
  validarFormConstructorPlatillo(guardarEn: 'biblioteca' | 'guia')
  {
    this.submitFormConstructorPlatillo = true;
    if(this.formConstructorPlatillo.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }
    if(this.formConstructorPlatillo.get('items').value.length <= 0) 
    {
      Swal.fire('Advertencia', 'Agrega por lo menos un alimento, suplemento o preparado.', 'warning');
      return;
    }
    this.createOrUpdatePlatilloFn(guardarEn);
  }
  createOrUpdatePlatilloFn(guardarEn: 'biblioteca' | 'guia')
  {
    let detallePlatillo = [];
    for(let ingrediente of this.formConstructorPlatillo.get('items').value)
    {
      // console.log(ingrediente)
      ingrediente.objInfo.porcionPlatillo = ingrediente.porcion
      ingrediente.objInfo.proteinasPlatillo = ingrediente.proteinas
      ingrediente.objInfo.grasaTotalPlatillo = ingrediente.grasaTotal
      ingrediente.objInfo.carbohidratosPlatillo = ingrediente.carbohidratos
      ingrediente.objInfo.caloriasPlatillo = ingrediente.calorias
      detallePlatillo.push(ingrediente.objInfo)
    }
    let platilloDocModel: PlatilloModel = {
      activo:        true,
      nombre:        this.formConstructorPlatillo.get('nombre').value,
      descripcion:   this.formConstructorPlatillo.get('descripcion').value,
      // imagen:        imagen,
      categoria:     this.formConstructorPlatillo.get('categoria').value,
      detalle:       detallePlatillo,
      calorias:      this.formConstructorPlatillo.get('calorias').value,
      carbohidratos: this.formConstructorPlatillo.get('carbohidratos').value,
      proteinas:     this.formConstructorPlatillo.get('proteinas').value,
      grasas:        this.formConstructorPlatillo.get('grasas').value,
      propietario:   this.userInfo.documentContainerId,
      empresaId:     this.userInfo.empresaId
    }

    // Busca en listado de platillos propios o en guia si existe el platillo
    let platilloEncontrado;
    if(guardarEn == 'biblioteca') platilloEncontrado = this.listaPlatillosPropios.find(p => p.nombre === platilloDocModel.nombre);
    if(guardarEn == 'guia') platilloEncontrado = this.editarGuia.detalle.find(p => p.nombre === platilloDocModel.nombre);
    if (platilloEncontrado) {
      console.log('platilloEncontrado', platilloEncontrado)
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe un platillo con el nombre: <b>"'+platilloDocModel.nombre+'"</b>.<br>¿Desea actualizarlo?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
          if(this.croppedImage != null && this.rawFile != null) {
            let nombre = this.rawFile.name;
            let tipo = this.rawFile.type;
            let croppedImage = this.croppedImage.replace(/^data:.+;base64,/, '')
            this.uploadService.uploadImage(environment.businessId, this.utilsService.create_UUID(), nombre, croppedImage, tipo).subscribe({
              next: (fileData: any) => {
                platilloDocModel.imagen = { url: fileData.fileName, nombre: nombre};
                if(guardarEn == 'biblioteca') {
                  platilloDocModel.documentId = platilloEncontrado.documentId; 
                  this.updatePlatilloFn(platilloDocModel, platilloEncontrado.documentId, guardarEn);
                } else if(guardarEn == 'guia') {
                  platilloDocModel.guiaId = this.editarGuia.documentId;
                  if(!platilloEncontrado.guiaId) this.createPlatilloFn(platilloDocModel, guardarEn);
                  if(platilloEncontrado.guiaId) {
                    platilloDocModel.documentId = platilloEncontrado.documentId; 
                    this.updatePlatilloFn(platilloDocModel, platilloEncontrado.documentId, guardarEn);
                  }
                }
              },
              error: (error) => {
                console.error(error)
              }
            })
          }
          else {
            if(this.previewUrl == null) platilloDocModel.imagen = null;
            if(guardarEn == 'biblioteca') {
              platilloDocModel.documentId = platilloEncontrado.documentId; 
              this.updatePlatilloFn(platilloDocModel, platilloEncontrado.documentId, guardarEn);
            } else if(guardarEn == 'guia') {
              platilloDocModel.guiaId = this.editarGuia.documentId;
              if(!platilloEncontrado.guiaId) this.createPlatilloFn(platilloDocModel, guardarEn);
              if(platilloEncontrado.guiaId) {
                platilloDocModel.documentId = platilloEncontrado.documentId; 
                this.updatePlatilloFn(platilloDocModel, platilloEncontrado.documentId, guardarEn);
              }
            }
          }
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    } else {
      if(this.croppedImage != null && this.rawFile != null) {
        let nombre = this.rawFile.name;
        let tipo = this.rawFile.type;
        let croppedImage = this.croppedImage.replace(/^data:.+;base64,/, '')
        this.uploadService.uploadImage(environment.businessId, this.utilsService.create_UUID(), nombre, croppedImage, tipo).subscribe({
          next: (fileData: any) => {
            platilloDocModel.imagen = { url: fileData.fileName, nombre: nombre};
            if(guardarEn == 'biblioteca') {
              this.createPlatilloFn(platilloDocModel, guardarEn);
            } else if(guardarEn == 'guia') {
              platilloDocModel.guiaId = this.editarGuia.documentId;
              this.createPlatilloFn(platilloDocModel, guardarEn);
            }
          },
          error: (error) => {
            console.error(error)
          }
        })
      }
      else {
        if(this.previewUrl == null) platilloDocModel.imagen = null;
        if(guardarEn == 'biblioteca') {
            this.createPlatilloFn(platilloDocModel, guardarEn);
        } else if(guardarEn == 'guia') {
          platilloDocModel.guiaId = this.editarGuia.documentId;
          this.createPlatilloFn(platilloDocModel, guardarEn);
        }
      }
    }
  }
  createPlatilloFn(platilloDocModel, guardarEn: 'biblioteca' | 'guia') {
    // console.log('createPlatilloFn - platilloDocModel', platilloDocModel)

    // Si se crea un platillo desde guia, busca si existe en la guia para eliminarlo y agregar el nuevo
    let platilloEncontrado;
    if(guardarEn == 'guia') {
      platilloEncontrado = this.editarGuia.detalle.find(p => p.nombre === platilloDocModel.nombre);
      if(platilloEncontrado) {
        if(!platilloEncontrado.guiaId) {
          // Buscar index del platillo por el nombre y documentId para eliminarla
          const index = this.editarGuia.detalle.findIndex(p => p.nombre === platilloEncontrado.nombre && p.documentId === platilloEncontrado.documentId);
          if(index != -1) {
            this.editarGuia.detalle.splice(index, 1);
          }
        }
      }
    }

    this.documentService.createDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      null,
      this.patternPlatillos,
      null,
      platilloDocModel,
    ).subscribe({
      next: (data) => {
        console.log('data createPlatillo', data);
        this.submitFormConstructorPlatillo = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Platillo guardado con éxito",
          showConfirmButton: false,
          timer: 1500
        });
        if(guardarEn == 'biblioteca') this.getPlatillos();
        if(guardarEn == 'guia') {
          this.editarGuia.detalle.push(data);
          this.calculoPlatillosGuia();
          this.actualizarInfoGuia();
          // this.actualizarInfoGuia(data.documentId);
          // this.getGuias();
          // this.editarGuia = null;
        }
        //this.inicializarFormConstructorPlatillo();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  updatePlatilloFn(platilloDocModel, documentId, guardarEn: 'biblioteca' | 'guia') {
    let title = ''
    if(platilloDocModel.activo) title = "Platillo actualizado con éxito";
    if(!platilloDocModel.activo) title = "Platillo eliminado con éxito";
    // console.log('updatePlatilloFn - platilloDocModel', platilloDocModel)

    let platilloEncontrado;
    if(guardarEn == 'guia') {
      platilloEncontrado = this.editarGuia.detalle.find(p => p.nombre === platilloDocModel.nombre);
      // console.log('platilloEncontrado', platilloEncontrado)
      if(platilloEncontrado) {
        // Buscar index del platillo por el nombre y documentId para eliminarla
        const index = this.editarGuia.detalle.findIndex(p => p.nombre === platilloEncontrado.nombre && p.documentId === platilloEncontrado.documentId);
        if(index != -1) {
          this.editarGuia.detalle.splice(index, 1);
        }
      }
    }

    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      documentId,
      this.patternPlatillos,
      null,
      platilloDocModel
    ).subscribe({
      next: (data) => {
        console.log(data);
        this.submitFormConstructorPlatillo = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: title,
          showConfirmButton: false,
          timer: 1500
        });
        this.getPlatillos();
        //this.inicializarFormConstructorPlatillo();
        if(guardarEn == 'guia') {
          this.editarGuia.detalle.push(data);
          this.calculoPlatillosGuia();
          this.actualizarInfoGuia();
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  /********* ELIMINAR PLATILLO *******/
  deletePlatilloFn(platilloDocModel) {
    Swal.fire({
      title: 'Eliminar platillo',
      html: '¿Seguro que desea eliminar la platillo: <b>"'+platilloDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        platilloDocModel.objInfo.activo = false;
        console.log(platilloDocModel)
        this.updatePlatilloFn(platilloDocModel.objInfo, platilloDocModel.objInfo.documentId, null);
      }
    })
  }
  inicializarFormConstructorPlatillo()
  {
    this.editarPlatilloExclusivoGuia = false;
    if(this.editarPlatillo)
    {
      this.editarPlatillo = false;
      const inputNombre: AbstractControl = this.formConstructorPlatillo.get('nombre');
      const inputCategoria: AbstractControl = this.formConstructorPlatillo.get('categoria');
      inputNombre.enable();
      inputCategoria.enable();
    }
    const arreglo = this.formConstructorPlatillo.get('items') as FormArray;
    while (arreglo.length !== 0) {
      arreglo.removeAt(0);
    }
    this.inicializarDataTableConstructorPlatillo();
    this.inicializarChart();
    this.errorFileType(false);
    this.formConstructorPlatillo.patchValue({
      nombre: '',
      categoria: '',
      descripcion: '',
      
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    })
  }
  get formConstructoPlatilloControl()
  {
    return this.formConstructorPlatillo.controls;
  }

  /**************** IMAGEN PLATILLO *****************/
  // Propiedades para Image Cropper
  imageChangedEvent: any = '';
  croppedImage: any = '';
  bolCroppedImg: boolean = false;
  // Información del archivo original
  selectedFile: File | null = null;
  rawFile: any;
  previewUrl: string | ArrayBuffer | null = null;
  fileChangeEvent(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];

      // Configurar el evento para el cropper
      this.imageChangedEvent = event;
      this.bolCroppedImg = true;

      // Almacenar detalles del archivo
      const reader = new FileReader();
      reader.onload = () => {
        this.rawFile = {
          file: reader.result,
          type: this.selectedFile?.type,
          name: this.selectedFile?.name
        };
        console.log('Raw File:', this.rawFile);
      };
      reader.readAsBinaryString(this.selectedFile);
    }
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64; // Imagen recortada en base64
    // console.log('Cropped Image:', this.croppedImage);
  }
  imageLoaded() {
    console.log('Image loaded');
  }
  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
  }
  loadImageFailed() {
    console.error('Failed to load image');
    this.errorFileType(true);
  }
  deleteImage() {
    this.errorFileType(false);
  }
  errorFileType(alert: boolean) {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    this.bolCroppedImg = false;
    this.selectedFile = null;
    this.previewUrl = null;
    this.rawFile = null;
    if (alert) {
      console.error('Invalid file type. Please select an image.');
    }
  }

  /*************** DETALLE PLATILLO ***************/
  detallePlatillo: any = {};
  modalDetallePlatilo(platillo)
  {
    // console.log(platillo)
    this.detallePlatillo = platillo;

    let caloriasPlatillo = platillo.cal;
    let carbohidratosPlatillo = platillo.gC;
    let proteinasPlatillo = platillo.gP;
    let grasasPlatillo = platillo.gG;
  
    // Calcula el porcentaje de cada macronutriente
    let porcentajeCarbohidratos = ((carbohidratosPlatillo * 4) / caloriasPlatillo) * 100 || 0;
    let porcentajeProteinas = ((proteinasPlatillo * 4) / caloriasPlatillo) * 100 || 0;
    let porcentajeGrasas = ((grasasPlatillo * 9) / caloriasPlatillo) * 100 || 0;

    // Ajusta los porcentajes para que sumen 100%
    let sumaPorcentajes = porcentajeCarbohidratos + porcentajeProteinas + porcentajeGrasas;
    porcentajeCarbohidratos = (porcentajeCarbohidratos / sumaPorcentajes) * 100;
    porcentajeProteinas = (porcentajeProteinas / sumaPorcentajes) * 100;
    porcentajeGrasas = (porcentajeGrasas / sumaPorcentajes) * 100;
  
    // Crea el gráfico con los porcentajes calculados
    this.createPieChartPlatillo('pieChartDetallePlatillo', porcentajeCarbohidratos, porcentajeProteinas, porcentajeGrasas);

    $('#modal-detallePlatillo').modal({backdrop: 'static', keyboard: false})
    $("#modal-detallePlatillo").modal('show');
  }
  goEditarPlatilloDesdeModalDetalle()
  {
    if(this.formConstructorPlatillo.get('items').value.length > 0)
    {
      Swal.fire('Advertencia', "No se puede agregar un platillo a una comida que ya tiene alimentos.<br> Elimine los alimentos de la comida si quiere agregar el platillo.", 'warning');
      return;
    }
    $("#modal-detallePlatillo").modal('hide');
    this.goEditarPlatillo(this.detallePlatillo.objInfo, 'biblioteca')
  }


  /**************************************************/
  /*************** AGREGAR GUIA MODAL ***************/
  /**************************************************/
  modalGuia()
  {
    console.log("nuevoGuia")
    this.inicializarDataTablePlatillosModal();
    this.inicializarDataTableConstructorGuiaModal();
    $('#modal-guia').modal({backdrop: 'static', keyboard: false})
    $("#modal-guia").modal('show');
  }
  agregarPlatilloAGuiaModal(platillo: PlatilloModel)
  {
    this.constructorGuiaModal.platillos.push(platillo)

    // Remover el platillo de listaPlatillos
    const index = this.listaPlatillos.indexOf(platillo);
    if (index !== -1) {
      this.listaPlatillos.splice(index, 1);
    }
    this.inicializarDataTablePlatillosModal();
    this.inicializarDataTableConstructorGuiaModal();
  }
  eliminarPlatilloDeGuiaModal(platillo: PlatilloModel) {
    console.log(`Eliminando platillo:`, platillo);
  
    // Remover el platillo de constructorGuiaModal.platillos
    const index = this.constructorGuiaModal.platillos.indexOf(platillo);
    if (index !== -1) {
      this.constructorGuiaModal.platillos.splice(index, 1);
    }
  
    // Agregar el platillo de vuelta a listaPlatillos si no está ya en la lista
    const existeEnLista = this.listaPlatillos.some(p => p.nombre === platillo.nombre);
    if (!existeEnLista) {
      this.listaPlatillos.push(platillo);
    }
    this.inicializarDataTablePlatillosModal();
    this.inicializarDataTableConstructorGuiaModal(); // Actualiza la tabla si es necesario
  }
  guardarGuiaModal()
  {
    // console.log("guardarGuiaModal()")
    // console.log(this.constructorGuiaModal)

    // Validar que el nombre no sea vacío o nulo
    if (this.constructorGuiaModal.nombre?.trim()) {
      console.log(this.constructorGuiaModal)
      let detalleGuia = [];
      let totalPlatillos = 0;
      let totalDesayunos = 0;
      let totalComidas = 0;
      let totalCenas = 0;
      let totalSnack1 = 0;
      let totalSnack2 = 0;
      for(let platillo of this.constructorGuiaModal.platillos)
      {
        totalPlatillos += 1;
        if(platillo.categoria == 'Desayuno') totalDesayunos += 1;
        if(platillo.categoria == 'Comida') totalComidas += 1;
        if(platillo.categoria == 'Cena') totalCenas += 1;
        if(platillo.categoria == 'Snack 1') totalSnack1 += 1;
        if(platillo.categoria == 'Snack 2') totalSnack2 += 1;
        detalleGuia.push(platillo)
      }
      let guiaDocModel: GuiaModel = {
        activo: true,
        nombre: this.constructorGuiaModal.nombre,
        totalDesayunos: totalDesayunos,
        totalComidas: totalComidas,
        totalCenas: totalCenas,
        totalSnack1: totalSnack1,
        totalSnack2: totalSnack2,
        detalle: detalleGuia,
        totalPlatillos: totalPlatillos,
        propietario: this.userInfo.documentContainerId,
        empresaId: this.userInfo.empresaId
      }
      console.log(guiaDocModel)
      this.createGuiaFn(guiaDocModel);
    } else {
      Swal.fire({
        toast: true, // Activa el estilo tipo Toast
        position: 'bottom-end', // Posición del mensaje
        icon: 'warning',
        title: 'Ingresa un nombre para la guía',
        showConfirmButton: false,
        timer: 3000, // Tiempo de duración del mensaje (3 segundos)
        timerProgressBar: true // Muestra una barra de progreso
      });
    }
  }
  
  inicializarGuiaModal()
  {
    // this.getPlatillos(); // Actualiza el listado de platillos
    // this.listaPlatillos = [...this.formPlatillos.get('items').value];
    this.getPlatillos();
    this.constructorGuiaModal.nombre = '';
    this.constructorGuiaModal.platillos = []; 

    this.inicializarDataTablePlatillosModal();
    this.inicializarDataTableConstructorGuiaModal();
  }

  createGuiaFn(guiaDocModel: GuiaModel) {
    this.documentService.createDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      null,
      this.patternGuias,
      null,
      guiaDocModel,
    ).subscribe({
      next: (data) => {
        // debugger
        console.log(data);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Guía guardada con éxito",
          showConfirmButton: false,
          timer: 1500
        });
        this.getGuias();
        this.inicializarGuiaModal();
        $("#modal-guia").modal('hide');
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  updateGuiaFn(guiaDocModel: GuiaModel, documentId) {
    let title = ''
    if(guiaDocModel.activo) title = "Guía actualizada con éxito";
    if(!guiaDocModel.activo) title = "Guía eliminada con éxito";

    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      documentId,
      this.patternGuias,
      null,
      guiaDocModel
    ).subscribe({
      next: (data) => {
        console.log(data);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: title,
          showConfirmButton: false,
          timer: 1500
        });
        this.getGuias();
        //this.inicializarFormConstructorGuia();
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
  /****************** ELIMINAR GUIA *****************/
  deleteGuiaFn(guiaDocModel) {
    Swal.fire({
      title: 'Eliminar guia',
      html: '¿Seguro que desea eliminar la guía: <b>"'+guiaDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        guiaDocModel.activo = false;
        this.updateGuiaFn(guiaDocModel, guiaDocModel.documentId)
      }
    })
  }
  /**************************************************/
  /******************* EDITAR GUIA ******************/
  filtrarGuiaPorCatePlatillo = ''
  goEditarGuia(guia)
  {
    if(!this.showTabConstructorGuia) this.showTabConstructorGuia = true;
    this.editarGuia = structuredClone(guia);
    this.filtrarPlatillosPorCategoria('todos');
    console.log(this.editarGuia)
  }
  actualizarInfoGuia()
  {
    if(this.editarGuia.detalle.length <= 0) 
    {
      Swal.fire('Advertencia', 'Agrega por lo menos un platillo a la guía.', 'warning');
      return;
    }
    let guiaDocModel: GuiaModel = {
      activo: true,
      nombre: this.editarGuia.nombre,
      totalDesayunos: this.editarGuia.totalDesayunos,
      totalComidas: this.editarGuia.totalComidas,
      totalCenas: this.editarGuia.totalCenas,
      totalSnack1: this.editarGuia.totalSnack1,
      totalSnack2: this.editarGuia.totalSnack2,
      detalle: this.editarGuia.detalle,
      totalPlatillos: this.editarGuia.totalPlatillos,
      propietario: this.userInfo.documentContainerId,
      empresaId: this.userInfo.empresaId
    }
    this.updateGuiaFn(guiaDocModel, this.editarGuia.documentId)
    console.log('guiaDocModel', guiaDocModel)
  }
  platillosFiltrados: any;
  filtrarPlatillosPorCategoria(opcion): void {
    console.log(opcion)
    this.filtrarGuiaPorCatePlatillo = opcion
    if (this.filtrarGuiaPorCatePlatillo === 'todos') {
      // Si la categoría es "todos", muestra todos los platillos
      this.platillosFiltrados = this.editarGuia.detalle;
    } else {
      // Filtra los platillos según la categoría seleccionada
      this.platillosFiltrados = this.editarGuia.detalle.filter((platillo: any) => platillo.categoria === this.filtrarGuiaPorCatePlatillo);
    }
    this.inicializarDataTableConstructorGuia();
  }
  
  disabledImportarPlatillos()
  {
    if(!this.editarGuia) return true;
    let platillosSeleccionados = 0;
    for(let platillo of this.formPlatillos.get('items')['controls'])
    {
      if(platillo.get('pla_asignado').value == true)
      {
        platillosSeleccionados = platillosSeleccionados + 1;
      }
    }
    if(platillosSeleccionados > 0) return false;
    return true;
  }
  importarPlatillosAGuia()
  {
    for(let platillo of this.formPlatillos.get('items')['controls'])
    {
      console.log(platillo.value)
      console.log(platillo.value.objInfo)
      if(platillo.get('pla_asignado').value == true)
      {
        let existePlatilloEnGuia = false;
        for(let plaGuia of this.editarGuia.detalle)
        {
          if(plaGuia.nombre == platillo.get('nombre').value) existePlatilloEnGuia = true;
        }
        if(existePlatilloEnGuia) {
          Swal.fire({
            toast: true, // Activa el estilo tipo Toast
            position: 'bottom-end', // Posición del mensaje
            icon: 'warning',
            title: 'El platillo ya existe en la guía',
            showConfirmButton: false,
            timer: 3000, // Tiempo de duración del mensaje (3 segundos)
            timerProgressBar: true // Muestra una barra de progreso
          });
        }
        else {
          this.editarGuia.detalle.push(platillo.value.objInfo)
        }
      }
    }
    this.calculoPlatillosGuia();
    this.filtrarPlatillosPorCategoria(this.filtrarGuiaPorCatePlatillo)
  }
  eliminarPlatilloDeGuia(platillo: PlatilloModel) {
    console.log(`Eliminando platillo:`, platillo);
    console.log(this.editarGuia.detalle)

    // Remover el platillo de constructorGuiaModal.platillos
    const index = this.editarGuia.detalle.indexOf(platillo);
    console.log('index', index)
    if (index !== -1) {
      this.editarGuia.detalle.splice(index, 1);
    }
    this.calculoPlatillosGuia();
    this.filtrarPlatillosPorCategoria(this.filtrarGuiaPorCatePlatillo)
    // this.inicializarDataTableConstructorGuia(); // Actualiza la tabla si es necesario
  }
  inicializarFormConstructorGuia()
  {
    // this.getPlatillos(); // Actualiza el listado de platillos
    // this.listaPlatillos = [...this.formPlatillos.get('items').value];
    this.getPlatillos();
    this.editarGuia = false;
    this.platillosFiltrados = [];
    this.filtrarGuiaPorCatePlatillo = ''
    this.inicializarDataTableConstructorGuia(); // Actualiza la tabla si es necesario
  }
  calculoPlatillosGuia()
  {
    let totalPlatillos = 0;
    let totalDesayunos = 0;
    let totalComidas = 0;
    let totalCenas = 0;
    let totalSnack1 = 0;
    let totalSnack2 = 0;
    for(let platillo of this.editarGuia.detalle)
    {
      totalPlatillos += 1;
      if(platillo.categoria == 'Desayuno') totalDesayunos += 1;
      if(platillo.categoria == 'Comida') totalComidas += 1;
      if(platillo.categoria == 'Cena') totalCenas += 1;
      if(platillo.categoria == 'Snack 1') totalSnack1 += 1;
      if(platillo.categoria == 'Snack 2') totalSnack2 += 1;
    }
    this.editarGuia.totalPlatillos = totalPlatillos;
    this.editarGuia.totalDesayunos = totalDesayunos;
    this.editarGuia.totalComidas = totalComidas;
    this.editarGuia.totalCenas = totalCenas;
    this.editarGuia.totalSnack1 = totalSnack1;
    this.editarGuia.totalSnack2 = totalSnack2;
    console.log('editarGuia', this.editarGuia)
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'Subtract' || event.key === '+' || event.key === 'Add') {
      event.preventDefault(); // Evita que se ingrese el signo "-"
    }
  }
}
